<img [src]="'../../assets/svg-weather/'+this.icon+'.svg'">
